import { useEffect, useState } from 'react';
import { fetchPackagesLearning } from '../api/api';
import { PackageLearning } from '../types';
import PackageCard from '../components/PackageCard';
import EmptyState from '../components/EmptyState';
import { useNavigate } from 'react-router-dom';

function PackagesPage() {
  const navigate = useNavigate(); 
  const [packages, setPackages] = useState<PackageLearning[]>([]);
  const [loading, setLoading] = useState(true);
  // State để quản lý chế độ xem (Grid/List)
  const [viewMode, setViewMode] = useState<'grid' | 'list'>(() => {
    const savedView = localStorage.getItem('viewMode') as 'grid' | 'list';
    return savedView || 'grid'; // Dùng giá trị đã lưu, nếu không có thì mặc định là 'grid'
  });

  useEffect(() => {
    localStorage.setItem('viewMode', viewMode);
  }, [viewMode]);

  useEffect(() => {
    const loadPackages = async () => {
      setLoading(true);
      try {
        const data = await fetchPackagesLearning();
        setPackages(data || []);
      } catch (error) {
        console.error("Failed to fetch packages:", error);
        setPackages([]);
      } finally {
        setLoading(false);
      }
    };
    loadPackages();
  }, []);

  if (loading) {
    return <div>Loading packages...</div>;
  }

  if (packages.length === 0) {
    return (
      <EmptyState
        title="No Learning Packages Found"
        message="Content is being updated. Please check back later or create a new package in the Content Studio."
        action={
          <button onClick={() => navigate(-1)} className="btn btn-primary">
            ‹ Go Back
          </button>
        }
      />
    );
  }

  return (
    <div>
      <div className="page-header">
        <h2>Packages</h2>
      </div>
      {/* Bộ chuyển đổi chế độ xem */}
      <div className="view-toggle glass-effect">
        <button className={viewMode === 'grid' ? 'active' : ''} onClick={() => setViewMode('grid')}>Grid</button>
        <button className={viewMode === 'list' ? 'active' : ''} onClick={() => setViewMode('list')}>List</button>
      </div>

      {/* Container có class động dựa trên viewMode */}
      <div className={viewMode === 'grid' ? 'topics-grid' : 'topics-list'}>
        {packages.map(pkg => (
          <PackageCard key={pkg.id} pkg={pkg} />
        ))}
      </div>
    </div>
  );
}

export default PackagesPage;